// This is an auto-generated file. Do not edit it directly — your changes will be overwritten the next time the model configs are generated.

 import type { IntegrationServiceIdConnection } from '@pigello/pigello-matrix';


import { useGetInstance, useGetList } from '@/requests/hooks';

import type {
  useGetGenericInstanceProps,
  useGetGenericListProps,
} from '@/requests/types';


export const useGetIntegrationServiceIdConnection = (
  options: useGetGenericInstanceProps<IntegrationServiceIdConnection>
) => {
  return useGetInstance<IntegrationServiceIdConnection>({
    ...options,
    modelName: 'integrationserviceidconnection'
  });
};

export const useGetIntegrationServiceIdConnectionList = (
  options: useGetGenericListProps<IntegrationServiceIdConnection>
) => {
  return useGetList<IntegrationServiceIdConnection>({
    ...options,
    modelName: 'integrationserviceidconnection'
  });
};
